import {
  Box,
  Button,
  Typography,
  useTheme,
  Grid,
  Paper,
} from "@mui/material";

import { tokens } from "../../theme/tokens";

const ShirtLandingPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box>
      <Box
        sx={{
          minHeight: { xs: "720px", md: "760px" },
          borderRadius: "16px",
          overflow: "hidden",
          position: "relative",
          display: "flex",
          alignItems: "center",
          px: { xs: 3, md: 8 },
          py: { xs: 8, md: 12 },
          background:
            "linear-gradient(135deg, #050505 0%, #101010 55%, #1a1a1a 100%)",
          boxShadow: "0 24px 80px rgba(0,0,0,0.35)",
        }}
      >
        <Box sx={{ maxWidth: "850px" }}>
          <Typography
            variant="overline"
            sx={{
              color: colors.scalpelTeal[500],
              letterSpacing: "0.22em",
              fontWeight: 700,
            }}
          >
            FSB NORTH WALES SMALL BUSINESS CONFERENCE • SPECIAL REPORT
          </Typography>

          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "3rem", md: "5.8rem" },
              lineHeight: 0.92,
              fontWeight: 900,
              color: "#fff",
              mt: 2,
              mb: 3,
              textTransform: "uppercase",
            }}
          >
            Knowledge loss costs more than staff turnover.
          </Typography>

          <Typography
            variant="h5"
            sx={{
              color: "rgba(255,255,255,0.9)",
              maxWidth: "700px",
              lineHeight: 1.5,
              mb: 4,
            }}
          >
            Most businesses do not realise how much critical knowledge exists
            only inside people’s heads - until that person is unavailable.
          </Typography>

          <Button
            variant="contained"
            color="secondary"
            size="large"
            href="/contact"
          >
            Start a Conversation
          </Button>
        </Box>
      </Box>

      <Grid container spacing={3} mt={5}>
        {[
          {
            title: "Hidden operational risks",
            text: "Find the weak points that are invisible during normal day-to-day work.",
          },
          {
            title: "Single points of failure",
            text: "Identify where your business depends too heavily on specific people.",
          },
          {
            title: "Knowledge trapped in teams",
            text: "Turn scattered know-how into clearer systems your team can actually use.",
          },
        ].map((item) => (
          <Grid item xs={12} md={4} key={item.title}>
            <Paper
              sx={{
                p: 3,
                height: "100%",
                borderRadius: "12px",
                backgroundColor: "background.paper",
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: colors.houndGold?.[500] }}
              >
                {item.title}
              </Typography>

              <Typography variant="body1">{item.text}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Box
        mt={6}
        p={4}
        sx={{
          borderRadius: "12px",
          backgroundColor: "background.paper",
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{ color: colors.houndGold?.[500] }}
        >
          Why this matters
        </Typography>

        <Typography variant="body1" sx={{ maxWidth: "850px", lineHeight: 1.7 }}>
          Staff turnover is visible. Knowledge loss is quieter. It shows up as
          mistakes, delays, repeated questions, inconsistent work, slow
          onboarding, and managers being dragged back into problems they thought
          were already solved.
          <br />
          <br />
          Operational Clarity helps businesses understand how they currently
          operate, how they want to operate, and where the gaps are creating
          risk.
        </Typography>
      </Box>

      <Box
        mt={6}
        p={4}
        textAlign="center"
        sx={{
          borderRadius: "12px",
          backgroundColor: colors.scalpelTeal[500],
          color: "#000",
        }}
      >
        <Typography variant="h4" fontWeight={800} gutterBottom>
          Curious what your hidden risks are?
        </Typography>

        <Typography variant="body1" mb={3}>
          Book a short conversation and I’ll help you identify where operational
          knowledge may be trapped inside your business.
        </Typography>

        <Button variant="contained" color="secondary" size="large" href="/contact">
          Get in Touch
        </Button>
      </Box>
    </Box>
  );
};

export default ShirtLandingPage;